import { CAMPAIGN_TYPE } from "../BulkCampaigns/BulkCampaignCreate";

import FollowUpCall from "./FollowUp/FollowUpCall";
import FollowUpSms from "./FollowUp/FollowUpSMS";
import FollowUpWhatsApp from "./FollowUp/FollowUpWhatsApp";

const CampaignFollowUpComponentRegistry = {
  [CAMPAIGN_TYPE.SMS]: (props) => <FollowUpSms {...props} />,
  [CAMPAIGN_TYPE.CALL]: (props) => <FollowUpCall {...props} />,
  [CAMPAIGN_TYPE.WHATSAPP]: (props) => <FollowUpWhatsApp {...props} />,
};

export default function FollowUpV2(props) {
  const { campaignType } = props;

  return CampaignFollowUpComponentRegistry[campaignType]({
    ...props,
  });
}
